<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        :reduced="data.reduced"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0" >
                <v-row no-gutters>
                    <v-col cols="4" v-if="!data.reduced">
                    <!-- componente a parte ha flag obbligatorio -->
                        <v-radio-group class="pa-0 ma-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                            <v-radio label="Fuori zona intervento" value="out"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="4">
                        <v-radio-group class="pa-0 ma-0" :disabled="preview" v-model="measures.change_masses" label="Abilita modifica zavorra e masse campione">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="!preview">
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn color="primary" @click="convertPlaceholders(measures.items)">Inizio test</v-btn>
                        <v-btn class="ml-4" color="primary" @click="resetValues(measures.items)">Reset</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters>
                <v-simple-table class="measure_table" dense>
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.weights}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.zavorra}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-center">{{data.block.conf.headers.result}}</th>
                            </tr>
                        </thead>
                        <tr v-for="(item,index) of measures.items" :key="item.index+'_'+measures.weightTotal">
                            <td class="table-text-blocks top-align">
                                <v-icon class="flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                <b v-else class="mr-6 align-end"></b>
                                <b class="align-end flex-shrink-0 flex-grow-1">{{index + 1}}</b>
                            </td>
                            <td class="table-blocks top-align with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.mass)"
                                @input="changeMass(item)" 
                                ></NumericField>
                            </td>
                            <td class="table-blocks top-align with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                :disabled="!can_change_masses"
                                v-model="item.sample_masses"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.mass)"
                                @blur="calcTotal(item)"
                                ></NumericField>
                            </td>
                            <td class="table-blocks top-align with_scroll">
                                <div v-if="needsRepeatability(item)" class="d-flex flex-column mt-4">
                                    <!-- <v-btn v-if="islastItem(index)" class="full-width mt-1" @click="useRepeatability(item)">Usa ripetibilità</v-btn> -->
                                    <v-btn v-if="needsRepeatability(item)" :class="item.button_class" @click="openRef(item.zavorra)">Test zavorra</v-btn>
                                </div>
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                :disabled="!can_change_masses"
                                v-model="item.zavorra"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.mass)"
                                @blur="calcTotal(item)"
                                ></NumericField>
                            </td>
                            <td class="table-blocks top-align with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.reading)"
                                @input="changeReading(item)" 
                                :placeholder="readingPlaceholder(item.mass)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="currMaxRange"
                                ></NumericField>
                            </td>
                        
                            <td class="table-blocks top-align with_scroll" v-if="measures.hi_res != 'on'">
                                <NumericField dense outlined
                                solo hide-details
                                class="text-left"
                                :readonly="preview"
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                @input="changeAddLoad(item)"
                                :placeholder="calculateAddLoadPlaceholder(item.reading)"
                                :class="addLoadWarning(item.addLoad, item.reading)"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="currMaxRange"
                                ></NumericField>
                            </td>
                            
                            <td class="table-text-blocks text-right top-align" v-if="measures.hi_res != 'on'">
                                <b>{{item.p | formatNumber}}</b>
                            </td>
                            
                            <td class="table-text-blocks text-right top-align">
                                <b>{{item.error | formatNumber}}</b>
                            </td>
                            
                            <td class="table-text-blocks text-right top-align">
                                <b>{{item.error_corr | formatNumber}}</b>
                            </td>
                        
                            <td class="table-text-blocks text-right top-align">
                                <b>{{item.mpe | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right top-align">
                                <StatusIcon :status="item.result" :tooltip_text="row_tooltip[item.result]" />
                            </td>
                        </tr>
                    </template>
                </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                        <div v-if="addLoad_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                        <div v-if="notMultiple" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori zavorra</b></div>
                        <div v-if="massOverflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Superata portata massima eseguire la prova modificando le masse campione</b></div>
                        <div v-if="notRightTotal" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Valore del carico totale differente dalla somma masse campione e zavorra</b></div>
                        <div v-if="can_change_masses" class="d-flex warning--text caption"><StatusIcon status="warning" small /><b>Modifica manuale masse campione e zavorra abilitata</b></div>
                    </div>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                    </div>
                </v-row>
            </v-container>                
            </div>
            <div v-else class="d-flex flex-column">
                <div class="pl-2 pb-2 text-h5 text-center"><StatusIcon status="failed" />Impossibile effettuare la prova</div>
                <div class="pl-2 pb-2 text-h6 text-center"><StatusIcon status="warning" />Test della zavorra mancante, incompleto o fallito</div>
                <div class="d-flex flex-shrink-0 flex-grow-1 py-2 justify-center">
                    <v-btn color="primary" @click="rebuildData()">Verifica completamento test</v-btn>
                </div>
            </div>
    </LayoutBlock>
</template>
<script>
import {linearity_zavorra_item} from "../../../../utils/itemBlockSchema"
import {BaseLeg} from "../../../../utils/baseLeg"
import LayoutBlock from "../../../../components/utils/LayoutBlock"
import StatusIcon from "../../../../components/utils/StatusIcon"
import Big from "big.js"
// import _ from 'lodash'

export default {
    components: {LayoutBlock, StatusIcon},    
    mixins:[BaseLeg],
    props: ["parent_res"],
    data(){
        return{
            pagination: {'rowsPerPage': -1},
            items: [],
            currMaxRange: null
        }
    },
    methods: {
        addRow(){
            let item = linearity_zavorra_item({
                index: this.measures.startingIndex
            })
            this.measures.startingIndex++
            this.measures.items.push(item)
        },
        
        async buildMeasures(){
            let testZavorraResult = this.getCommonData()
            console.log("$$ test result", testZavorraResult)
            // if (!testZavorraResult || testZavorraResult == "0" || testZavorraResult.result == "uncomplete" || testZavorraResult.result == "failed"){
            //     //result is null when the test is not included
            //     //result is 0 when the test is present but yet to be opened
            //     //result is uncomplete when the test is still in progress
            //     console.log("$$ debug, no common data")
            //     return
            // }
            this.measures = {
                items: [],
                restricted_mode: "off",
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                change_masses: "off",
                weightTotal: 0,
                startingIndex: 0,
                result: 'uncomplete'
            }
            
            
            this.measures.hi_res = this.has_hi_res ? this.parent_res : 'off'
            this.measures.startingIndex = this.data.block.conf.min_readings
            let catVals = await this.buildWithCategory()
            if(catVals){
                for (let i = 0; i< catVals.length; i++ ){
                    let currCatVal = catVals[i]
                    let currMpe = this.calc_MPE(this.calcMinRange(currCatVal), currCatVal)
                    let item = linearity_zavorra_item({
                        index: i,
                        mass: currCatVal,
                        mpe: currMpe
                    })
                    this.measures.items.push(item)
                }
                
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++ ){
                    let item = linearity_zavorra_item({
                        index: i,
                        mass: "0",
                        mpe: "0"
                    })
                    this.measures.items.push(item)
                }
            }
            // decidere se lasciare la parte precedente o togliere, buildRows sovrascrive i dati
            if(testZavorraResult && testZavorraResult.mass > 0 && testZavorraResult.result == "done"){
                this.buildRows(testZavorraResult.mass)
            }

        },
        findRow(items, index){
            return items.find(function(a){
                return a.index == index
            })
        },
        changeMass(row){
            if(row.mass){
                let range = this.calcMinRange(row.mass)
                row.mpe = this.calc_MPE(range, row.mass)
            }
        },

        
        calcError(row){
            if (row.reading != null && row.reading != ''){
                if(this.measures.hi_res == 'on'){
                    row.error = this.differenceInt(row.reading, row.mass)
                    this.calculateResult(row)
                } else {
                    if(row.addLoad != null && row.addLoad != ''){
                        row.error = this.differenceInt(row.p, row.mass)
                        if(this.checkLoad(row.addLoad, row.mass)){
                            this.calculateResult(row)
                        } else {
                            row.result = 'failed'
                        }
                    } else {
                        row.result = "uncomplete"
                    }
                } 
            } else {
                row.result = 'uncomplete'
            }
        },
        calcDiff(){
            let start_error = null
            for(let i=0; i<this.measures.items.length;i++){
                let row = this.measures.items[i]
                this.calcError(row)
                if(i == 0){
                    start_error = row.error
                } else {
                    row.error_corr = this.differenceInt(row.error, start_error)
                }
            }
        },
        saveFirst(){
            
        },
        handlePlaceholders(){
            this.convertPlaceholders(this.measures.items)
        },
        saveMeasures() {
            let block = this.data.block
            this.calcBlockResult()
            if(this.data.reduced == false){
                let temp = []
                temp.push(this.measures.items[0])
                temp.push(this.measures.items[this.measures.items.length -1])
                if(this.data.common_data[block.name]){
                    this.data.common_data[block.name][block._id].value = temp
                }
                this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id, common_data: this.data.common_data })
            } else {
                this.$emit("updateMeasures", {name: this.data.block.name, measures: this.measures})
            }
        },
        removeRow(index){
            let item = this.measures.items.splice(index,1)
            console.log("$$ item removed", item)
        },
        openRef(zavorra){
            this.$emit('openRepDialog', zavorra)
        },
        getRepeatabilityCommon(){
            if(this.data.common_data.repeatability){
                for(let key in this.data.common_data.repeatability){
                    return this.data.common_data.repeatability[key].value
                }
            }
            return null
        },
        needsRepeatability(item){
            if(this.isRestricted){
                return false
            }
            if(item.zavorra && item.zavorra > 0){
                let z = Big(item.zavorra)
                let repCommon = this.getRepeatabilityCommon()
                let repVal = repCommon && repCommon.mass ? repCommon.mass : 0
                if(z.eq(repVal)){
                    return false
                } else if (z.eq(this.measures.weightTotal)){
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        islastItem(index){
            if(this.measures && this.measures.items && index == this.measures.items.length - 1){
                return true
            }
            return false
        },
        useRepeatability(item){
            let repCommon = this.getRepeatabilityCommon()
            let repVal = repCommon && repCommon.mass ? repCommon.mass : 0
            item.zavorra = repVal
            item.mass = this.round(Big(item.sample_masses).plus(item.zavorra))
        }
    },
    computed: {
        notRightTotal(){
            for(let item of this.measures.items){
                if(item.mass && item.sample_masses && item.zavorra){
                    let mass = Big(item.mass)
                    let sum = Big(item.sample_masses).plus(item.zavorra)
                    if(!mass.eq(sum)){
                        console.log("trovato ", item)
                        return true
                    }
                }
            }
            return false
        },
        massOverflow(){
            let maxRange = this.findMaxRange()
            for(let item of this.measures.items){
                let mass = Big(item.mass)
                if (mass.gt(maxRange.max)){
                    return true
                }
            }
            return false
        },
        isRestricted(){
            let repCommon = this.getRepeatabilityCommon()
            if(repCommon && repCommon.restricted && repCommon.restricted == "on"){
                return true
            }
            return false
        }
    }
 
}
</script>
